interface SubscriptionStatusSource {
  status?: unknown;
  stripeStatus?: unknown;
}

const TERMINAL_SUBSCRIPTION_STATUSES = new Set([
  'canceled',
  'cancelled',
  'expired',
  'incomplete_expired',
]);

export function isTerminalSubscriptionStatus(status: unknown): boolean {
  return typeof status === 'string' && TERMINAL_SUBSCRIPTION_STATUSES.has(status);
}

export function isTerminalSubscription(
  subscription: SubscriptionStatusSource | null | undefined,
): boolean {
  if (!subscription) return false;

  return isTerminalSubscriptionStatus(subscription.stripeStatus) ||
    isTerminalSubscriptionStatus(subscription.status);
}
